import React from "react";

/**
 * Xentra brand marks.
 *
 *   <XentraIcon />       – small navy "X" emicon from xentra.co.uk, used in sidebars
 *                          and topbars beside the "XENTRA" text label.
 *   <XentraWordmark />   – full "xentra" wordmark in white (for dark hero panels)
 *                          or dark navy (for white panels).
 */

const ICON_URL =
  "https://www.xentra.co.uk/wp-content/uploads/2024/11/xentra-icon-blue-X-crop.png";

export function XentraIcon({ className = "h-7 w-7" }) {
  return (
    <img
      src={ICON_URL}
      alt="Xentra"
      className={className}
      data-testid="xentra-icon"
    />
  );
}

export function XentraWordmark({ variant = "white", size = 10, className = "" }) {
  // variant="white" → transparent-background white logo (for dark surfaces)
  // variant="dark"  → navy-text wordmark (for white surfaces)
  const src =
    variant === "white"
      ? "/brand/xentra-wordmark-white.png"
      : "/brand/xentra-logo.png";
  return (
    <img
      src={src}
      alt="Xentra"
      className={`h-${size} w-auto object-contain ${className}`}
      data-testid="xentra-wordmark"
    />
  );
}

// Legacy export kept to avoid breakage in case it's imported elsewhere.
export function XentraLogo({ variant = "dark", size = 9, className = "" }) {
  return <XentraWordmark variant={variant === "light" ? "white" : "dark"} size={size} className={className} />;
}

export default XentraIcon;
